/* ============================================================================
   ONGROK — product-card hover ("flip") images, loaded only when actually needed.

   WHAT THE FLIP IS
   snippets/product-listing.liquid renders a SECOND image per product card when
   settings.image_flip is on. stylesheet.css stacks it over the primary and crossfades it:

       .reveal .hidden                        { position:absolute; opacity:0; transition:.3s }
       .product-index-inner:hover .reveal .hidden { z-index:1; opacity:1 }

   THE PROBLEM THIS SOLVES
   opacity:0 is NOT display:none. The element keeps a real box in the viewport, and Chrome's
   lazy-loader decides on GEOMETRY, not paint — so every flip image downloaded in full whether
   or not anyone ever hovered.

   MEASURED on /collections/all, 2026-09-11, at the 400w candidate a 390px phone picks:
       43 primary product photos     521 KiB
       41 flip images                634 KiB   <- 54% of the page's mobile image weight
   and the first card's flip image crossed the lazy threshold at the same moment as the LCP
   image, competing with it for bandwidth at precisely the wrong time.

   WHY NOT JUST HIDE THEM ON MOBILE
   That was tried first: @media (hover: none) { ... display:none }. It is WRONG, because
   :hover DOES fire on touch devices — mobile browsers apply "sticky hover" on tap, so the
   crossfade really does play when you tap a card. Hiding it removes a real effect. Verified
   on a real phone 2026-09-11. (It also silently lost to Vantage's own
   `.reveal .hidden { display:block !important }`, so it did nothing anyway.)

   WHAT THIS DOES INSTEAD
   Liquid renders the flip <img> with NO src and NO srcset — both are parked in data-src and
   data-srcset (snippets/basic-responsive-image.liquid, the defer_all branch). An <img> with
   no src issues no request, so the bytes are simply never spent. This file promotes the
   attributes on the FIRST interaction with a card, which works for both input models:
     desktop — pointerover fires as the cursor enters, and the 0.3s opacity transition covers
               the fetch, so the image is there by the time the crossfade finishes
     touch   — touchstart/pointerover fire on tap, the same gesture that triggers sticky hover

   DELEGATION, NOT PER-CARD LISTENERS. One listener on document instead of 43 per collection
   page, and it keeps working for cards added later by filtering or infinite scroll without
   anything having to re-bind.

   pointerover, NOT pointerenter: pointerenter does not bubble, so it cannot be delegated.
   promote() is idempotent and strips data-src once used, so repeat events cost a failed
   querySelectorAll and nothing else.

   LOADED SITE-WIDE from snippets/header-mobile-fixes.liquid, because product-listing renders
   on collection pages, search results and the homepage carousels alike.
   ============================================================================ */
(function () {
  'use strict';

  if (window.__ogFlip) return;
  window.__ogFlip = true;

  function promote(card) {
    var imgs = card.querySelectorAll('.reveal .hidden img[data-src]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var set = img.getAttribute('data-srcset');
      /* srcset before src: with both present the browser picks from srcset, so setting src
         first would briefly commit it to the fallback file and fetch the wrong candidate. */
      if (set) img.setAttribute('srcset', set);
      img.setAttribute('src', img.getAttribute('data-src'));
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    }
  }

  function onInteract(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest('.product-index-inner');
    if (card) promote(card);
  }

  /* passive: these never preventDefault, and touchstart in particular must not be treated as
     a potential scroll blocker. focusin covers keyboard tabbing through the grid. */
  document.addEventListener('pointerover', onInteract, { passive: true });
  document.addEventListener('touchstart', onInteract, { passive: true });
  document.addEventListener('focusin', onInteract);
})();